import { useEffect, useRef } from 'react';
import './looping-video.css';

type LoopingVideoProps = {
  src: string;
  alt: string;
  className?: string;
};

/** Demostración que el visitante puede reproducir y pausar. */
export function LoopingVideo({ src, alt, className }: LoopingVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    // Leave playback in the visitor's hands; only pause when it is no longer visible.
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) video.pause();
    });
    const pauseWhenHidden = () => { if (document.hidden) video.pause(); };
    observer.observe(video);
    document.addEventListener('visibilitychange', pauseWhenHidden);
    return () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', pauseWhenHidden);
    };
  }, []);

  return (
    <video
      ref={videoRef}
      className={className ? `looping-video ${className}` : 'looping-video'}
      src={src}
      controls
      muted
      playsInline
      preload="metadata"
      disablePictureInPicture
      aria-label={alt}
    />
  );
}
